import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createWashingMachinePartApi } from '@/apis/washingMachinePart'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { SuccessResponse } from '@/types'
import { CreateWashingMachinePartRequest } from '@/types/apis/washingMachinePart/CreateWashingMachinePartRequest'

export const useCreateWashingMachinePart = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<SuccessResponse>()

  const create = useCallback(
    async (request: CreateWashingMachinePartRequest) => {
      try {
        setLoading(true)
        const res = await createWashingMachinePartApi(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.create.success') })
        navigate(routes.washingMachinePart.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.create.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    createWashingMachinePart: create,
    response,
  }
}
